<template>
    <v-card>
        <v-data-table
            :footer-props="{itemsPerPageOptions:[1,5,10]}"
            :headers="headers"
            :items="items"
            :options.sync="options"
            :single-expand="singleExpand"
            :expanded.sync="expanded"
            :server-items-length="total"
            :loading="loading"
            show-expand
            class="elevation-0 dataTable pt-3"
        >

            <template
                v-slot:body.prepend="{ headers }"
            >
                <tr>
                    <td>
                        <v-text-field
                            v-model="name"
                            label="Nome..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td>
                        <v-select
                            class="mt-4"
                            v-model="action"
                            chips
                            offset-y
                            :items="selects"
                            item-text="text"
                            item-value="value"
                            label="Tipo da alteração"
                        ></v-select>
                    </td>
                    <td>
                        <v-menu
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    class="mt-5"
                                    v-model="date"
                                    label="Data..."
                                    persistent-hint
                                    prepend-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dateCalendar"
                                range
                                no-title
                            ></v-date-picker>
                        </v-menu>
                    </td>
                    <td class="td-actions" >
                        <v-btn
                            class="mt-4 btn-action"
                            depressed
                            color="primary"
                            v-on:click="getData()"
                        >
                            Buscar
                        </v-btn>
                        <v-btn
                            class="mt-4 mb-4 btn-action"
                            depressed
                            color="#FBC02D"
                            v-on:click="getCleanFilter()"
                        >
                            Limpar
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Histórico de alterações - {{ hotelName }}</v-toolbar-title>
                </v-toolbar>
            </template>
            <template v-slot:item.user.name="{ item }">
                <span v-if="isActionExternalCreation(item)">Usuário externo</span>
                <span v-else>{{ getUserName(item.user) }}</span>
            </template>
            <template v-slot:item.action_date="{ item }">
                {{ parseDate(item.action_date, 'DD/MM/YYYY H:mm') }}
            </template>
            <template v-slot:item.action="{ item }">
                <v-chip v-if="item.action === 1"
                        class="ma-2"
                        color="green"
                        text-color="white"
                >
                    {{ getAction(item) }}
                </v-chip>
                <v-chip v-if="item.action === 2 "
                        class="ma-2"
                        color="yellow"
                        text-color="black"
                >
                    {{ getAction(item) }}
                </v-chip>
                <v-chip v-if="item.action === 3 "
                        class="ma-2"
                        color="red"
                        text-color="white"
                >
                    {{ getAction(item) }}
                </v-chip>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <v-container width="max-content">
                        <v-row>
                            <v-col class="detail-title">
                                Campo
                            </v-col>
                            <v-col class="detail-title">
                                Valor
                            </v-col>
                        </v-row>
                        <v-row
                            class="detail-row"
                            v-for="detail in item.details" :key="detail.id"
                        >
                            <v-col class="detail">
                                {{ detail.field_affected }}
                            </v-col>
                            <v-col class="detail">
                                {{ detail.value }}
                            </v-col>
                            <v-col cols="12" class="detail-divider">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                    </v-container>
                </td>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import moment from "moment";

export default {
    name: "ListChangesHotel",

    data: () => ({
        dialog: false,
        hotelName: '',
        name: '',
        action: '',
        action_date: '',
        until: '',
        loading: true,
        total: 0,
        dateCalendar: [],
        date: '',
        selects: [
            {text: 'Sem Filtro', value: ''},
            {text: 'Criação', value: '1'},
            {text: 'Atualização', value: '2' },
            {text: 'Exclusão', value: '3'}
        ],
        options: {
            sortDesc: [true],
        },
        headers: [
            {text: 'Nome', value: 'user.name'},
            {text: 'Tipo da alteração', value: 'action'},
            {text: 'Data', value: 'action_date'},
            {text: '', value: 'data-table-expand'},
        ],
        items: [],
        expanded: [],
        singleExpand: false,
    }),

    mounted() {
        if (Object.keys(this.$route.query).length) {
            const {sort, sortDesc, page, perPage, name, action, action_date, until} = this.$route.query;
            if (sort) {
               this.sort = sort;
            }
            if (sortDesc) {
                this.sortDesc = sortDesc;
            }
            if (page) {
                this.page = page;
            }
            if(perPage) {
                this.options.perPage = perPage;
            }
            if(name) {
                this.name = name;
            }
            if(action) {
                this.action = action;
            }
            if(action_date) {
                this.action_date = action_date;
            }
            if(until) {
                this.until = until;
            }
        }

        axios.get(`/api/hotel/${this.$route.params.id}`)
            .then(res => {
                this.hotelName = res.data.name;
            });
    },

    methods: {
        getData() {
            this.loading = true;
            const {sortBy, sortDesc, page, itemsPerPage} = this.options;
            const query = `sort=${sortBy}&sortDesc=${sortDesc}&page=${page}&perPage=${itemsPerPage}
                &name=${this.name}&action=${this.action}&action_date=${this.action_date}&until=${this.until}`;
            this.$router.push({
                query: {
                    sort: sortBy,
                    sortDesc: sortDesc,
                    page: page,
                    perPage: itemsPerPage,
                    userName: this.userName,
                    action: this.action,
                    action_date: this.action_date,
                    until: this.until,
                }
            });

            axios.get(`/api/hotel/list-changes/${this.$route.params.id}?${query}`)
                .then(res => {
                    this.items = res.data;
                    this.total = res.data.total;
                    this.loading = false;
                });
        },

        getAction(item) {
            if (item.action == '1') {
                return 'Criação';
            }
            if (item.action == '2') {
                return 'Atualização';
            }
            if (item.action == '3') {
                return 'Exclusão';
            }
        },

        parseDate(date, format) {
            return moment(date).format(format);
        },

        formatDate (dateCalendar) {
            if (!dateCalendar) return null

            const [year, month, day] = dateCalendar.split('-')
            return `${day}/${month}/${year}`
        },

        getCleanFilter() {
            this.$router.replace({'query': null});
            window.location.reload();
        },

        renderImage(field) {
            return field === 'Imagem principal' || field === 'Fotos do hotel' || field === 'Print do acordo';
        },

        getUserName(user) {
            if (user === null) {
                return 'Sistema';
            }
            return user.name;
        },

        isActionExternalCreation (item) {
            return item.hotel && item.hotel.is_external === 1 && item.action === 1;
        }
    },
    watch: {
        options: {
            handler() {
                this.getData()
            },
            deep: true,
        },
        dateCalendar () {
            let action_date = this.formatDate(this.dateCalendar[0])
            if (this.dateCalendar[1] != null ){
                let until = this.formatDate(this.dateCalendar[1])
                this.date = action_date + " ate " + until
                this.action_date = this.dateCalendar[0]
                this.until = this.dateCalendar[1]

            }
        },
    }
}
</script>

<style scoped>
.td-actions {
    text-align: center;
}

.btn-action {
    width: 80%;
    text-align: center;
}

.detail, .detail p {
    font-size: small;
    padding: 4px;
    margin: 0;
}

.detail-title {
    font-weight: bolder;
}

.detail-row:hover {
    background-color: #EEE;
}

.detail-image {
    width: 50px;
}

.detail-divider {
    padding: 0;
}
</style>
